import { ref, onMounted, onUnmounted } from 'vue';

const COLLAPSE_THRESHOLD = 1024;
const STORAGE_KEY = 'menu-collapsed';

export function useNarrowViewportAutoCollapse() {
    const savedCollapsed = window.localStorage ? localStorage.getItem(STORAGE_KEY) === 'true' : false;
    const startCollapsed = window.innerWidth < COLLAPSE_THRESHOLD || savedCollapsed;

    const isMenuCollapsed = ref(startCollapsed);
    const isLogoShown = ref(!startCollapsed);

    let lastWidth = window.innerWidth;

    function handleResize() {
        const width = window.innerWidth;
        if (width === lastWidth) return;
        lastWidth = width;

        if (width < COLLAPSE_THRESHOLD) {
            if (!isMenuCollapsed.value) {
                isMenuCollapsed.value = true;
                isLogoShown.value = false;
            }
        } else {
            const saved = window.localStorage ? localStorage.getItem(STORAGE_KEY) === 'true' : false;
            isMenuCollapsed.value = saved;
            isLogoShown.value = !saved;
        }
    }

    onMounted(() => window.addEventListener('resize', handleResize));
    onUnmounted(() => window.removeEventListener('resize', handleResize));

    return { isMenuCollapsed, isLogoShown };
}
